export const about = {
	about: {
		techStack: {
			title: "Tech Stack & Skills",
			description: "Technology stack and skill set used in work and personal development",
		},
		contact: {
			title: "Contact",
			description: "Feel free to reach out.",
		},
		socials: {
			title: "Social Media",
		},
	},
} as const;
